var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React, { forwardRef } from 'react';
import { ChevronLeft, ChevronRight } from '@olxbr/ds-icons';
import { Button, Container } from './styles';
export const CarouselArrow = forwardRef((_a, ref) => {
  var {
      variant = 'left',
      hideArrowsOnMobile
    } = _a,
    props = __rest(_a, ["variant", "hideArrowsOnMobile"]);
  const handleClick = e => {
    props.onClick && (props === null || props === void 0 ? void 0 : props.onClick(e));
  };
  return React.createElement(Button, Object.assign({
    "data-ds-component": "CarouselArrow-Button",
    className: "carousel-arrow-".concat(variant),
    "data-hideonmobile": hideArrowsOnMobile,
    "data-variant": variant,
    "aria-label": variant === 'left' ? 'Ir para o slide anterior' : 'Ir para o próximo slide',
    type: "button",
    onClick: handleClick
  }, props, {
    ref: ref
  }), React.createElement(Container, null, variant === 'left' ? React.createElement(ChevronLeft, null) : React.createElement(ChevronRight, null)));
});
CarouselArrow.displayName = 'CarouselArrow';